module.exports = __webpack_public_path__ + "img/GameConsole-right.cac2aab8.png";